// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainSliderForm__container {
    padding: 0px
}
.mainSliderForm__container .title {
    border-bottom-width: 1px;
    padding-bottom: 0.5rem;
    text-align: center
}
.mainSliderForm__container .checkbox {
    display: flex;
    align-items: center;
    gap: 1rem
}
.mainSliderForm__container .checkbox input {
    width: auto;
    cursor: pointer
}
.mainSliderForm__btn {
    height: 3rem;
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}`, "",{"version":3,"sources":["webpack://./src/components/widgetFrom/FormForSlider/formForSlider.css"],"names":[],"mappings":"AACI;IAAA;AAAU;AAGV;IAAA,wBAAgC;IAAhC,sBAAgC;IAAhC;AAAgC;AAGhC;IAAA,aAA8B;IAA9B,mBAA8B;IAA9B;AAA8B;AAG9B;IAAA,WAA4B;IAA5B;AAA4B;AAG5B;IAAA,YAA4E;IAA5E,WAA4E;IAA5E,kBAA4E;IAA5E,0DAA4E;IAA5E,yBAA4E;IAA5E,uBAA4E;IAA5E,oBAA4E;IAA5E,mDAA4E;IAA5E,+EAA4E;IAA5E,mGAA4E;IAA5E;AAA4E","sourcesContent":[".mainSliderForm__container {\n    @apply p-0;\n}\n.mainSliderForm__container .title {\n    @apply text-center border-b pb-2;\n}\n.mainSliderForm__container .checkbox{\n    @apply flex items-center gap-4;\n}\n.mainSliderForm__container .checkbox input {\n    @apply w-auto cursor-pointer;\n}\n.mainSliderForm__btn {\n    @apply w-full bg-green-500 text-white h-12 uppercase tracking-wide shadow-lg;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
